export default __webpack_public_path__ + "static/media/instaf.83747e99.svg";